import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Topnav from './components/Topnav';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import ContactUs from './pages/ContactUs';
import About from './pages/About';
import Mission from './pages/Mission';
import MyStory from './pages/MyStory';
import Reviews from './pages/Reviews';
import ScrollToTop from './components/ScrollToTop';
import Inquiry from './pages/Inquiry';
import Jobs from './pages/Jobs';




function App() {
  return (
    <div className='App'>
      <BrowserRouter>
        <ScrollToTop />
        <Topnav />
        <Navbar />
        <div className="PageContent">
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/services' element={<Services />} />
            <Route path='/contact-us' element={<ContactUs />} />
            <Route path='/about-us' element={<About />} />
            <Route path='/mission' element={<Mission />} />
            <Route path='/story' element={<MyStory />} />
            <Route path='/reviews' element={<Reviews />} />
            <Route path='/inquiry' element={<Inquiry />} />
            <Route path='/jobs' element={<Jobs />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
